import Reflux from "reflux";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
import { singletonStore, singletonActions } from "logic/singleton";
export const PreferencesActions = singletonActions(
  "core.Preferences",
  () => Reflux.createActions({
    loadUserPreferences: { asyncResult: true },
    saveUserPreferences: { asyncResult: true }
  })
);
const convertPreferences = (preferences) => {
  const convertedPreferences = {};
  Object.entries(preferences).forEach(([key, value]) => {
    if (value === "true") {
      convertedPreferences[key] = true;
    } else if (value === "false") {
      convertedPreferences[key] = false;
    } else {
      convertedPreferences[key] = value;
    }
  });
  return convertedPreferences;
};
export const PreferencesStore = singletonStore(
  "core.Preferences",
  () => Reflux.createStore({
    listenables: [PreferencesActions],
    URL: qualifyUrl("/users/"),
    saveUserPreferences(userName, preferences, callback = () => {
    }, displaySuccessNotification = true) {
      const convertedPreferences = convertPreferences(preferences);
      const url = `${this.URL + encodeURIComponent(userName)}/preferences`;
      const promise = fetch("PUT", url, { preferences: convertedPreferences }).then(
        () => {
          if (displaySuccessNotification) {
            UserNotification.success("User preferences successfully saved");
          }
          callback(preferences);
        },
        (errorThrown) => {
          UserNotification.error(
            `Saving of preferences for "${userName}" failed with status: ${errorThrown}`,
            "Could not save user preferences"
          );
        }
      );
      PreferencesActions.saveUserPreferences.promise(promise);
      return promise;
    }
  })
);
